<template>
  <!-- <a-affix :offset-top="0"> -->
  <a-tabs
    v-model="tabPane"
    class="main-tabs"
    type="card"
    @change="tabPaneChangeHandler"
  >
    <a-tab-pane key="photo">
      <span slot="tab"> <a-icon type="picture" />Фото </span>

      <!--photo table-->
      <photo-tab-table />
    </a-tab-pane>

    <a-tab-pane key="video">
      <span slot="tab"> <a-icon type="video-camera" />Видео </span>

      <!--video table-->
      <video-tab-table />
    </a-tab-pane>

    <span slot="tabBarExtraContent">
      <a-button
        style="margin-right: 10px"
        type="primary"
        @click="
          $router.push({
            name: 'gallery-create',
            params: { type: $route.query.tab }
          })
        "
      >
        <a-icon type="plus" />
        Добавить {{ tabNames[$route.query.tab][$i18n.locale] }}
      </a-button>
    </span>
  </a-tabs>
  <!-- </a-affix> -->
</template>

<script>
export default {
  components: {
    "photo-tab-table": () => import("@/views/gallery/photo-tab-table"),
    "video-tab-table": () => import("@/views/gallery/video-tab-table")
  },
  data: () => ({
    tabPane: "photo",
    tabNames: {
      video: {
        ru: "видео",
        uz: "video"
      },
      photo: {
        ru: "фото",
        uz: "rasm"
      }
    }
  }),
  watch: {
    "$route.query.tab": {
      handler() {
        this.tabPane = this.$route.query.tab
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.$route.query.tab) {
      this.$router.replace({ query: { tab: "photo" } })
    }
  },
  methods: {
    tabPaneChangeHandler(e) {
      this.$router.push({ query: { tab: e } })
    }
  }
}
</script>
